import React, { useState, useEffect, useContext, useRef } from "react";

import MunicipalitiesBasicForm from './edit-municipality-forms/hoa-municipalities-basic-form';
import MunicipalityFeesForm from './edit-municipality-forms/hoa-municipality-fees-form';
import MunicipalityAdditionalForm from './edit-municipality-forms/hoa-municipality-additional-form';

import EditIcon from '@mui/icons-material/Edit';
import LocationIcon from '@mui/icons-material/LocationOnOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Tab, Tabs, Badge, Button, IconButton } from "@mui/material";

import config from '../../hoa-config';
import datastore from '../../store/hoa-datastore'
import { GlobalContext } from '../../context/hoa-global-context';
import dashboardServices from '../../services/hoa-dashboard-api-service';

import '../hoa-styles.scss';
import './hoa-municipality-styles.scss'

import ViewComponent from './hoa-muncipality-view-comp';
import DeleteContainerModal from '../delete-modal/hoa-delete-modal';
import BillableItemsModal from '../billableItems-modal/billable-items-modal';
import { compareMunicipality, compareObject, isValueExistInState, shouldCreateHoaLogs } from '../../utility/compare-item';
import { saveNewLogsInDatastore } from "../../utility/change-log";
import TryagainModal from "../Tryagain-modal/TryagainModal";
import { isEmailValid, isFaxValid, isPhoneValid, isValidHttpUrl } from "../../utility/input-field-validation";
import LoadingComponent from "../loading-component/loading-component";
import EditCancelConfirmationModal from "../../shared-components/edit-cancel-confirmation";


interface AddMunicipalitiesProps {
    setView: any;
    setSuccess: any;
    view: string;
    previousMuncipality:any;
}

const stateList : any = {
    name: '',
    market: '',
    city: '',
    state: '',
    zip: '',
    officeAddress: '',
    phone: '',
    email: '',
    fax: '',
    website: '',
    registrationResolutionForm : '',
    registrationRequirements: '',
    ownerRenewalForm: '',
    renewalInstructions: '',
    tenantLeaseRegistrationFormUrl : [],
    countyOrMunicipalityRenewalForm : []
}

const feesStateList : any = {
    registrationFee: '',
    renewalFrequency: '',
    landLordRegistrationFee : '',
    landlordRenewalFrequency : '',
    registrationAdminFee: '',
    registrationConvenienceFee: '',
    residentialLandlordTaxSchedule: '',
    penalty : '',
    stateMandateFee: '',
    renewalFee: '',
    applicationFee: '',
    renewalProcessingFee: '',
}

const additionalInfoStateList : any = {
    isInspectionMandatory : '',
    iseSelfInspectionAvailable : '',
    inspectionFee : '',
    reInspectionFee : '',
    inspectionScheduleMethod : '',
    isCodeOfComplianceRequired:'',
    commonCodeViolations: '',
    isRentalCertificateNeeded: '',
    isOutstandingTaxPaymentAllowed: '',
    preOccupencyPenalty : '',
    isLocalAgentRequired: '',
    exteriorInspection: '',
    interiorInspection: '',
    isOutstandingViolationAllowed: '',
}

export default function AddMuniciplaities(props : AddMunicipalitiesProps) {
    const { selectedValues, hoa, updateHoaData, muncipality, updateMuncipalityData, 
        updateView, updateSelectedValues, viewMoreDetails, setViewMoreDetails, 
        changeActiveMenu, activeMenu, activeTab, updateActiveTab 
    } = useContext<any>(GlobalContext);
    
    const [state, setState] = useState(JSON.parse(JSON.stringify(stateList)));
    const [isDisabled, setIsDisabled] = useState(true);
    const [checkError, setCheckError] = useState(false);
    const [feesState, setFeesState] = useState(JSON.parse(JSON.stringify(feesStateList)));
    const [additionalInfoState, setAdditionalInfoState] = useState(additionalInfoStateList);
    const [loading, setLoading] = useState(false);
    const [feesWarning, setFeesWarning] = useState(false);
    const [additionalInfoWarning, setAdditionalInfoWarning] = useState(false);
    const [showApiErrorModal, setShowApiErrorModal] = useState(false)
    const [files, setFiles] = useState({
        tenantLeaseRegistrationFormUrl : [],
        countyOrMunicipalityRenewalForm: []
    })
    const [isMoreDetailsStateEnabled, toggleisMoreDetailsStateEnabled] = useState(false)
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [selectedBillItem, setSelectedBillItem] = useState(null);
    const [linkedEntryId, setLinkedEntryId] = useState(null);
    const [evidenceLink, setEvidenceLink] = useState(null);
    const [isBillableItemsModal, setIsBillableItemsModal] = useState(false);
    const [isCancelClicked, setIsCancelClicked] = useState(false);
    const [documentId, setDocumentId] = useState("")
    const [isDocumentIdVerified, setIsDocumentIdVerified] = useState(false)

    const didMount = useRef(true);

    const isObjectEmpty = (object : any)=>{
        if(object) {
            for(const item of Object.values(object)){
                if(item && item !=='')
                    return false;
            }
        }
        return true;
    }

    useEffect(()=>{
        toggleisMoreDetailsStateEnabled(Object.keys(viewMoreDetails).length !== 0)
        return ()=>{
            const tmpValues: any = state;
            Object.keys(tmpValues).map((key) => {
                if(typeof(tmpValues[key]) === 'string'){
                    tmpValues[key] = '';
                } else if(Array.isArray(tmpValues[key])){
                    tmpValues[key] = [];
                }
            });
            setState(tmpValues)
        }
    }, [])

    useEffect(()=>{
        if(props.view === 'view') {
            setFeesWarning(isObjectEmpty(selectedValues.fees));
            setAdditionalInfoWarning(isObjectEmpty(selectedValues.additionalInfo));
        }
        else if(props.view === "update"){
            let tempState : any;
            tempState = JSON.parse(JSON.stringify(selectedValues));

            if(tempState.fees){
                setFeesState(tempState.fees);
                setFeesWarning(isObjectEmpty(tempState.fees));
            } else {
                setFeesWarning(true)
            }
            if(tempState.additionalInfo){
                setAdditionalInfoState(tempState.additionalInfo);
                setAdditionalInfoWarning(isObjectEmpty(tempState.additionalInfo));
            } else {
                setAdditionalInfoWarning(true)
            }
            delete tempState.fees;
            delete tempState.additionalInfo;
            setState(tempState);
            setCheckError(true);

        }
    },[selectedValues.objectId,props.view])

    useEffect(()=>{
        if(didMount.current){
            didMount.current = false;
            return
        }
        else if(props.view !== 'view') {
            setFeesWarning(isObjectEmpty(feesState));
            setAdditionalInfoWarning(isObjectEmpty(additionalInfoState));
        }
    },[feesState, additionalInfoState])

    const responsiveHeight = props.view === "add" ? datastore.responsiveHeight : datastore.responsiveHeightWithtab;

    const createLogs = async (status:string,objectId:string,prevState?:any,updatedState?:any,extensions?:any) => {
        // delete parseObjects
        let prev = {...prevState}
		delete prev._parseObject
		let update = {...updatedState}
		delete update._parseObject

        // set primaryEvent
        var events:any = [];
		var primaryEvent = config.changeLongActionsMuncipality[status];

        // manage extensions
        if(Array.isArray(extensions) && extensions.length > 0) {
            extensions.map(extension => {
                events.push(`${primaryEvent} ${extension}`);
            });
        }
        else {
            events.push(primaryEvent);
        }

        let connectedHoaIds = [];
        if(shouldCreateHoaLogs(prev, update) && props.view == "update") {
            let response = await dashboardServices.getHoasOfMunicipality(objectId);
            if(response.status == 200 && Array.isArray(response.data)) {
                connectedHoaIds = response.data.map(hoa => {
                    return hoa.objectId;
                });

                events.push("Update Municipality Information");
            }
        }

        const logMessage = {
            events:events,
            user: datastore.ownerInformation.name,
            billItem: selectedBillItem,
            linkedEntryId: linkedEntryId,
            evidenceLink: evidenceLink,
            prevState:prev,
            updatedState:update,
            type:'Municipality',
            tagTypeId:objectId
        }
        
        const result = await dashboardServices.createLogs(logMessage);
        saveNewLogsInDatastore(result.data, datastore);
        const municipalityLogResonse = result.data;

        // create logs for connected HOAs
        if(Array.isArray(connectedHoaIds) && connectedHoaIds.length > 0) {
            var hoaLogMessages: any[] = [];
            for(let i=0; i<connectedHoaIds.length; i++) {
                hoaLogMessages.push({
                    events:["Update Municipality Information"],
                    user: datastore.ownerInformation.name,
                    billItem: selectedBillItem,
                    linkedEntryId: linkedEntryId,
                    evidenceLink: evidenceLink,
                    prevState:prev,
                    updatedState:update,
                    type:'Hoa',
                    tagTypeId:connectedHoaIds[i]
                })
            }

            const hoaLogMessagesResult = await dashboardServices.createMultipleLogs(hoaLogMessages);
            
            if(hoaLogMessagesResult.data && Array.isArray(hoaLogMessagesResult.data) && hoaLogMessagesResult.data.length > 0) {
                let connectedHoaLogIds = [];

                for(let i = 0; i < hoaLogMessagesResult.data.length; i++) {
                    connectedHoaLogIds.push(hoaLogMessagesResult.data[i].objectId);
                    const tmpData = hoaLogMessagesResult.data[i];
                    tmpData.createdAt = new Date(tmpData.createdAt).toLocaleString('en-US')
                    var hoaId = tmpData.tagTypeId;
                    if(datastore.createdLogs[hoaId]){
                        let tempLogs = {...datastore.createdLogs[hoaId]};
                        tempLogs.data = [tmpData, ...datastore.createdLogs[hoaId].data];
                        tempLogs.count = datastore.createdLogs[hoaId].count + 1;
                        datastore.createdLogs[hoaId]= tempLogs;
                    } else {
                        datastore.createdLogs[hoaId] = {};
                        let tempLogs = {...datastore.createdLogs[hoaId]};
                        tempLogs.data = [tmpData];
                        tempLogs.pageNumber = 1;
                        tempLogs.isLastPage = true;
                        tempLogs.count = 1;
                        datastore.createdLogs[hoaId] = tempLogs;
                    }
                }

                const connectedLogs = {
                    connectedHoaLogIds
                }

                municipalityLogResonse.connectedLogs = connectedLogs;

                const updateMunicipalityLogResult = await dashboardServices.updateLogs(municipalityLogResonse);

				if(updateMunicipalityLogResult && updateMunicipalityLogResult.status == 200) {
					// update datastore
                    const updateMunicipalityLogResonse = updateMunicipalityLogResult.data;
                    updateMunicipalityLogResonse.createdAt = new Date(updateMunicipalityLogResonse.createdAt).toLocaleString('en-US')
                    if(datastore.createdLogs[objectId]){
                        let tempLogs = {...datastore.createdLogs[objectId]};
                        tempLogs.data = [updateMunicipalityLogResonse, ...datastore.createdLogs[objectId].data];
                        tempLogs.count = datastore.createdLogs[objectId].count + 1;
                        datastore.createdLogs[objectId]= tempLogs;
                    } else {
                        datastore.createdLogs[objectId] = {};
                        let tempLogs = {...datastore.createdLogs[objectId]};
                        tempLogs.data = [updateMunicipalityLogResonse];
                        tempLogs.pageNumber = 1;
                        tempLogs.isLastPage = true;
                        tempLogs.count = 1;
                        datastore.createdLogs[objectId] = tempLogs;
                    }
				}
            }
        }
    }

    const onDeleteClick = async () => {
        setLoading(true);
        const value = await dashboardServices.removeMuncipality(selectedValues.objectId);
        if(value && value.data){
            await createLogs('remove',selectedValues.objectId);
            const updatedData = muncipality.data.filter(((value:any) => value.objectId !== selectedValues.objectId))
            updateMuncipalityData({
                ...muncipality,
                data: updatedData,
            });
            props.setSuccess(true);
            changeActiveMenu(activeMenu,false, "", -1);
            updateView('remove-from-list')
            setLoading(false);
        }
    }

    const onViewMoreDetailsState = async () => {
        setLoading(true);
        let hoaData = hoa.data;
        let hoaIndex = 0;
        let selectedHoa = hoaData.find((value: any, index: number) => {
            if(value.municipality.objectId === selectedValues.objectId){
                hoaIndex = index;
                return value;
            }
        })

        let data = muncipality.data;
        let index = 0;
        let selectedMuni = data.find((value: any, index1: number) => {
            if(value.objectId === selectedValues.objectId){
                index = index1;
                return value;
            }
        });
        selectedMuni = state;
        selectedMuni.objectId  = selectedValues.objectId;
        selectedMuni.fees = {...feesState};
        selectedMuni.additionalInfo = {...additionalInfoState};
        data[index] = selectedMuni;
        selectedHoa.municipality = selectedMuni;
        hoaData[index] = selectedHoa;
        const res = await dashboardServices.updateMunicipality(selectedMuni, files);
        if(res.status === 200){
            await createLogs(props.view,selectedValues.objectId,props.previousMuncipality,res.data)
            updateMuncipalityData({
                ...muncipality,
                data: data,
            });
            updateHoaData({
                ...hoa,
                data: hoaData,
            });
            props.setSuccess(true);
            updateSelectedValues(selectedMuni);
            props.setView("view");
            setLoading(false);
        }
    }

    const clearState = () => {
        setFeesState(JSON.parse(JSON.stringify(feesStateList)))
    }

    const onCancelYesClick = () => {
        // changeActiveMenu(activeMenu,false, "", -1);
        // clearState();
        // if(isMoreDetailsStateEnabled) {
        //     props.setView("view");
        // } else {
        //     props.setView("list");
        // }
        clearState();
        if (Object.keys(selectedValues).length > 0) {
			props.setView("view");
		}else {
			props.setView("list");
		}
        updateSelectedValues({...props.previousMuncipality});
        setIsCancelClicked(false);
    }

    const onCancelClick = () => {
        setIsCancelClicked(!isCancelClicked)
    }

    const saveBtnClicked = async () => {
        if(props.view === 'update') {
			setIsBillableItemsModal(true);
		}
		else {
			onSaveClick();
		}
    }

    useEffect(() => {
        if(props.view === 'update' && !compareMunicipality(selectedValues, state) 
        || (files && ((Array.isArray(files.countyOrMunicipalityRenewalForm) && files.countyOrMunicipalityRenewalForm.length > 0) || (Array.isArray(files.tenantLeaseRegistrationFormUrl) && files.tenantLeaseRegistrationFormUrl.length > 0)) )
    ) {
        setIsDisabled(false);
    }
    if(props.view === 'update' && ((!selectedValues.fees && isValueExistInState(feesState)) || (selectedValues && selectedValues.fees && !compareObject(selectedValues.fees, feesState)))) {
        setIsDisabled(false);
    }
    if(props.view === 'update' && ((!selectedValues.additionalInfo && isValueExistInState(additionalInfoState)) || (selectedValues && selectedValues.additionalInfo && !compareObject(selectedValues.additionalInfo, additionalInfoState)))) {
        setIsDisabled(false);
    }
    },[selectedValues, state, feesState, additionalInfoState])

    const onSaveClick = async () =>{
        setCheckError(true);
        let error = false;
        for (const [key, value] of Object.entries(state)) {
            if(!value){
                if(key === "fax" || key === "email" || key === "phone" || key === "registrationResolutionForm" || key ==="ownerRenewalForm" || key === "registrationRequirements" || key === "renewalInstructions" || key==="tenantLeaseRegistrationFormUrl" || key === 'countyOrMunicipalityRenewalForm') {
                    continue;
                }
                else {
                    error = true;
                    break;
                }
            }
            if(key==="email" && (state.email && !isEmailValid(value as string))){
                error = true;
                break;
            }
            if(key==="phone" && (state.phone && !isPhoneValid(value as string))){
                error = true;
                break;
            }
            if(key==="fax" && (state.fax && !isFaxValid(value as string))){
                error = true;
                break;
            }

            if(key==="website" && !isValidHttpUrl(value as string)){
                error = true;
                break;
            }

            if(key==="ownerRenewalForm" && !isValidHttpUrl(value as string)){
                error = true;
                break;
            }

            if(key==="registrationResolutionForm"  && !isValidHttpUrl(value as string)){
                error = true;
                break;
            }

        }
        if(!error){
            if(isMoreDetailsStateEnabled) {
                onViewMoreDetailsState()
                return;
            }
            try{
            setShowApiErrorModal(false)
            setLoading(true);

            if(props.view === "update"){
                let data = muncipality.data;
                let index = 0;
                let selectedMuni = data.find((value: any, index1: number) => {
                    if(value.objectId === selectedValues.objectId){
                        index = index1;
                        return value;
                    }
                });

                let overviewChanged = false;
                let feesChanged = false;
                let additoinalInfoChanged = false;

                if(!compareMunicipality(selectedValues, state) 
                    || (files && ((Array.isArray(files.countyOrMunicipalityRenewalForm) && files.countyOrMunicipalityRenewalForm.length > 0) || (Array.isArray(files.tenantLeaseRegistrationFormUrl) && files.tenantLeaseRegistrationFormUrl.length > 0)) )
                ) {

                    overviewChanged = true;
                }
                if(selectedValues && selectedValues.fees && !compareObject(selectedValues.fees, feesState)) {
                    feesChanged = true;
                }
                if(selectedValues && selectedValues.additionalInfo && !compareObject(selectedValues.additionalInfo, additionalInfoState)) {
                    additoinalInfoChanged = true;
                }

                selectedMuni = state;
                selectedMuni.objectId  = selectedValues.objectId;
                selectedMuni.fees = {...feesState};
                selectedMuni.additionalInfo = {...additionalInfoState};
                data[index] = selectedMuni;
                const res = await dashboardServices.updateMunicipality(selectedMuni, files);
                if(res.status === 200){
                    let extensions = [];
                    if(overviewChanged) {
                        extensions.push("Overview Information");
                    }
                    if(feesChanged) {
                        extensions.push("Fees Information");
                    }
                    if(additoinalInfoChanged) {
                        extensions.push("Additional Information");
                    }
                    
                    if(Array.isArray(extensions) && extensions.length>0) {
                        await createLogs(props.view,selectedValues.objectId,props.previousMuncipality,res.data, extensions);
                    }

                    updateMuncipalityData({
                        ...muncipality,
                        data: data,
                    });
                    props.setSuccess(true);
                    updateSelectedValues(selectedMuni);
                    props.setView("view");
                }
            } else if(props.view === 'add'){
                const res = await dashboardServices.addMunicipality(state, files);
                const tmpData = [res.data,...muncipality.data]
                updateMuncipalityData({
                    ...muncipality,
                    data: tmpData,
                });
                await createLogs(props.view,res.data.objectId,{},res.data)
                if(res.status === 200){
                    props.setSuccess(true);
                }
                props.setView("list");
            }
            setFiles({
                tenantLeaseRegistrationFormUrl : [],
                countyOrMunicipalityRenewalForm: []
            })
            setLoading(false);
        }
        catch(error){
            setShowApiErrorModal(true)
            setLoading(false)
        }
        }

    }

    return (
        <div style={{ justifyContent: 'center', fontSize: '20px', width: "100%", height: "100%", boxSizing: "border-box" }}>
            <LoadingComponent loading={loading} />
            <div style={{ display: 'flex', flexDirection: 'column', border: "1px solid #E8E8E8", borderRadius: "4px", width: "100%" }}>
                <div style={{ borderBottom: "1px solid #E8E8E8", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "0 24px", alignItems:'center', height:'102px' }}>
                    <div style={{ display:'flex'}}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {
                                props.view === "update" ?
                                    <span className="titleText">Update {activeTab === 0 ? 'Information' : (activeTab === 1 ? 'Municipality Fees' : 'Additional Details')}</span>
                                    : props.view === "view" ?
                                        <div style={{ display:'flex'}}>
                                            <span className="titleText">{selectedValues.name}</span>
                                            {/* {feesWarning || additionalInfoWarning ? <div className="title-status text-3E3E3E-13px">'Incomplete'</div> : ''} */}
                                        </div>
                                        :
                                        <span className="titleText">Add New Municipality</span>
                            }
                            {
                                props.view === "update" ?
                                    <span className="helperText">Please fill up the necessary information to update municipality details.</span>
                                    : props.view === "view" ?
                                        <div style={{ display: "flex", flexDirection: "row" }}> <LocationIcon /> <span className="helperText" style={{ marginLeft: "5px", fontSize: "14px" }}>{selectedValues.officeAddress}</span> </div>
                                        :
                                        <span className="helperText">Please fill up the necessary information to add municipalities.</span>
                            }
                        </div>
                    </div>               
                        <TryagainModal
                            open={showApiErrorModal}
                            errorMessage="Save failed. Please try again."
                            onClose={()=>setShowApiErrorModal(false)}
                            onTryAgain={onSaveClick}
                        />
                    {
                        props.view !== 'view' &&
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Button variant="outlined" color="primary" disabled={loading} style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
                                onClick={isDisabled ? onCancelYesClick : onCancelClick}>Cancel</Button>
                            <Button disabled={props.view === 'update' ? isDisabled : false} variant="contained" color="primary" style={{ height: "40px", padding: "5px 25px" }} onClick={saveBtnClicked}>
                                {loading ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    }
                    {
                        props.view === 'view' &&
                        <div style={{ display: "flex", flexDirection: "row" }}>
                                {
                                    datastore.isUserPermitted('Municipality', 'update') &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<EditIcon />}
                                        style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
                                        onClick={() => {
                                            if (activeTab === 3) {
                                                updateActiveTab(0)
                                            }
                                            props.setView("update")
                                        }}>
                                        Edit
                                    </Button>
                                }
                                {
                                    datastore.isUserPermitted('Municipality', 'view', 'delete') &&
                                    <IconButton
                                        disabled={isMoreDetailsStateEnabled}
                                        onClick={() => setIsDeleteModal(true)}
                                        style={{
                                            height: '40px',
                                            border: '1px solid #E8E8E8',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        <DeleteOutlineIcon
                                            style={{
                                                width: '20px',
                                                height: '20px'
                                            }}
                                        />
                                    </IconButton>
                                }
                        </div>
                    }
                </div>
                {
                    props.view === "add" ?
                    <MunicipalitiesBasicForm muncipality={muncipality} updateMuncipalityData={updateMuncipalityData} updateSelectedValues={updateSelectedValues} view={props.view} isValidHttpUrl={isValidHttpUrl} state = {state} setState = {setState} isFaxValid={isFaxValid} isPhoneValid = {isPhoneValid} isEmailValid = {isEmailValid} checkError = {checkError} responsiveHeight={responsiveHeight} files={files} setFiles={setFiles} isUpdating={false}/>
                    :
                    <>
                        <div style = {{ borderBottom: '1px solid #E8E8E8' }}>
                        <Tabs value={activeTab} onChange={(event, value) => {updateActiveTab(value)}}>
                            <Tab label="Overview" value={0} style={{minWidth:"143px", textTransform: "none"}}/>
                                {
                                    datastore.userRole != config.userRoles.OrganizationUser &&
                                        <Tab  value={1} style={{minWidth:"143px", textTransform: "none"}}
                                            label={
                                                feesWarning ?
                                                <Badge style={{textTransform:"none"}} badgeContent={'i'} color="warning"><div style={{marginRight:"10px"}}>Municipality Fees</div></Badge>
                                                :
                                                <span>Municipality Fees</span>
                                        }/>
                                }
                                {
                                    datastore.userRole != config.userRoles.OrganizationUser &&
                                        <Tab value={2} style={{minWidth:"143px", textTransform: "none"}}
                                            label={
                                                additionalInfoWarning ?
                                                <Badge badgeContent={'i'} color="warning"><div style={{marginRight:"10px"}}>Additional Details</div></Badge>
                                                :
                                                <span>Additional Details</span>
                                        }/>
                                }
                                {
                                    datastore.userRole != config.userRoles.OrganizationUser && props.view === 'view' && <Tab label="Change Log" value={3} style={{minWidth:"143px", textTransform: "none"}}/>
                                }
                        </Tabs>
                        </div>
                        {
                            activeTab === 0 ? (
                                props.view === "update" ?
                                    <MunicipalitiesBasicForm muncipality={muncipality} updateMuncipalityData={updateMuncipalityData} updateSelectedValues={updateSelectedValues} view={props.view} isValidHttpUrl={isValidHttpUrl} state = {state} setState = {setState} isFaxValid={isFaxValid} isPhoneValid = {isPhoneValid} isEmailValid = {isEmailValid} checkError = {checkError} responsiveHeight = {responsiveHeight} files={files} setFiles={setFiles} isUpdating={true}/>
                                :
                                <ViewComponent feesWarning={feesWarning} additionalInfoWarning={additionalInfoWarning} selectedValues={selectedValues} tabIndex={0} />
                            )
                            : activeTab === 1 ? (
                                props.view === "update" ?
                                    <MunicipalityFeesForm state = {feesState} setState = {setFeesState} checkError = {checkError} responsiveHeight = {responsiveHeight}/>
                                :
                                <ViewComponent feesWarning={feesWarning} additionalInfoWarning={additionalInfoWarning} selectedValues={selectedValues} tabIndex={1} />
                            )
                            : activeTab === 2 ? (
                                props.view === "update" ?
                                    <MunicipalityAdditionalForm state = {additionalInfoState} setState = {setAdditionalInfoState} responsiveHeight = {responsiveHeight}/>
                                :
                                <ViewComponent feesWarning={feesWarning} additionalInfoWarning={additionalInfoWarning} selectedValues={selectedValues} tabIndex={2} />
                            ) :
                            <ViewComponent feesWarning={feesWarning} additionalInfoWarning={additionalInfoWarning} selectedValues={selectedValues} tabIndex={3} />

                        }
                    </>
                }
            </div>
            <DeleteContainerModal type={"Municipality"} onDeleteClick={onDeleteClick} isDeleteModal={isDeleteModal} setIsDeleteModal={setIsDeleteModal} />
            <BillableItemsModal 
                billItems={datastore.billableItemsOptions.municipality}
                selectedBillItem={selectedBillItem}
                setSelectedBillItem={setSelectedBillItem}
                evidenceLink={evidenceLink}
                setEvidenceLink={setEvidenceLink}
                onSaveClick={onSaveClick}
                isBillableItemsModal={isBillableItemsModal}
                setIsBillableItemsModal={setIsBillableItemsModal} 
                tagType={'Municipality'} 
                setLoading={setLoading}
                view={'add'}
                linkedEntryId={linkedEntryId}
                setLinkedEntryId={setLinkedEntryId}
                documentId={documentId}
				setDocumentId={setDocumentId}
				isDocumentIdVerified={isDocumentIdVerified}
				setIsDocumentIdVerified={setIsDocumentIdVerified}
            />
            <EditCancelConfirmationModal
                isCancelClicked={isCancelClicked}
                setIsCancelClicked={setIsCancelClicked}
                onCancelYesClick={onCancelYesClick}
            />
        </div>
    )
}